const isSkuSelectorKillswitchEnabled = () =>
    !!Sephora.configurationSettings?.genAIChatBotSkuSelector?.isEnabled;

const selectSkuSelectorEnabled = () => isSkuSelectorKillswitchEnabled();

export {
    selectSkuSelectorEnabled, isSkuSelectorKillswitchEnabled
};
